"use client";

import { Layout } from 'antd';
import styles from './Offer.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useTranslations } from 'next-intl';

const { Content } = Layout;

const offerData = [
  {
    id: 1,
    title: "title1",
    desc: "desc1",
  },
  {
    id: 2,
    title: "title2",
    desc: "desc2",
  },
  {
    id: 3,
    title: "title3",
    desc: "desc3",
  },
];

export const Offer = () => {
  const t = useTranslations("aiAgent.offer");

  return (
    <Content className={styles.root}>
      <ScrollReveal className={styles.root_title}>
        <h1>{t("title")}</h1>
        <h2>{t("subtitle")}</h2>
      </ScrollReveal>

      <ScrollReveal className={styles.root_cards}>
        {offerData.map((item) => (
          <section key={item.id} className={styles.root_cards_item}>
            <div className={styles.root_cards_item_count}>
              {String(item.id).padStart(2, "0")}
            </div>

            <div className={styles.root_cards_item_text}>
              <h3 className={styles.root_cards_item_title}>{t(item.title)}</h3>
              <h6 className={styles.root_cards_item_desc}>{t(item.desc)}</h6>
            </div>
          </section>
        ))}
      </ScrollReveal>
    </Content>
  );
};
